import '../PrivatePolicy/PrivatePolicy.css';
import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { navigationBarState } from '../../../states/NavigationBar';

function TermsOfService() {
    const setNavigationBarState = useSetRecoilState(navigationBarState);

    useEffect(() => {
        setNavigationBarState({
            title: '이용약관',
            'left-item': { type: 'back' },
        });
    }, [setNavigationBarState]);

    return (
        <div className="privacy-page">
            <div className="privacy-container">
                <div className="privacy-header">
                    <h1 className="privacy-title">회원 및 이용약관</h1>
                    <p className="privacy-subtitle">주식회사 케이비티영어교육 서비스 이용약관</p>
                </div>

                <div className="privacy-content">
                    {/* 제1장 총칙 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">1</span>
                            총칙
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제1조 (목적)</div>
                            <div className="privacy-section-text">
                                <p>
                                    본 약관은 주식회사 케이비티영어교육(이하 "회사")이 운영하는 온라인 플랫폼(이하 "사이트")의
                                    회원 가입, 이용, 정보관리, 자격검정 서비스 연계에 관한 기본 사항을 규정함을 목적으로 합니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제2조 (적용범위)</div>
                            <div className="privacy-section-text">
                                <p>
                                    본 약관은 사이트를 이용하는 모든 회원에게 적용하며, 자격검정 및 인증, 교육 서비스 등
                                    사이트에서 제공되는 모든 서비스의 기본 기준으로 합니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제3조 (정의)</div>
                            <div className="privacy-section-text">
                                <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
                            </div>
                            <ul className="privacy-list">
                                <li>회원: 사이트에서 정한 절차에 따라 가입을 완료한 자</li>
                                <li>일반회원: 기본 서비스를 이용하는 회원</li>
                                <li>응시회원: 자격시험 응시를 위한 회원</li>
                                <li>자격관리회원: 자격증 발급 및 조회 기능을 이용하는 회원</li>
                                <li>개인정보: 개인을 식별할 수 있는 정보</li>
                                <li>본인인증: 스마트폰 인증 등 본인확인 과정</li>
                                <li>서비스: 시험 접수, 응시, 점수확인, 자격증 발급 등 기능</li>
                            </ul>
                        </div>
                    </div>

                    {/* 제2장 회원 가입 및 등급 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">2</span>
                            회원 가입 및 등급
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제4조 (회원 가입 절차)</div>
                            <div className="privacy-section-text">
                                <p>
                                    회원 가입은 사이트에서 정한 방식에 따라 이름, 연락처 등 필요한 정보를
                                    제출함으로써 완료됩니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제5조 (회원 유형 및 권한)</div>
                            <ul className="privacy-list">
                                <li>일반회원: 기본 기능 이용</li>
                                <li>응시회원: 시험 접수 및 응시 가능</li>
                                <li>자격관리회원: 자격증 발급 및 재발급 신청 가능</li>
                            </ul>
                        </div>
                    </div>

                    {/* 제3장 회원 정보 관리 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">3</span>
                            회원 정보 관리
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제6조 (정보 관리 및 변경)</div>
                            <div className="privacy-section-text">
                                <p>
                                    회원은 제공한 정보를 사실과 부합하게 유지해야 하며, 변경 시 즉시 수정하여야 합니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제7조 (본인확인)</div>
                            <div className="privacy-section-text">
                                <p>
                                    자격시험 응시 및 자격증 발급에는 반드시 본인확인이 필요합니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제8조 (계정 보안)</div>
                            <div className="privacy-section-text">
                                <p>
                                    회원은 계정 정보를 타인과 공유해서는 안 됩니다.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 제4장 서비스 이용 및 제한 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">4</span>
                            서비스 이용 및 제한
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제9조 (서비스 제공 범위)</div>
                            <div className="privacy-section-text">
                                <p>
                                    사이트는 시험 접수, 성적조회, 자격증 발급 등 서비스를 제공합니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제10조 (이용 제한)</div>
                            <div className="privacy-section-text">
                                <p>
                                    부정행위 등 규정 위반 시 서비스 이용이 제한될 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 제5장 자격시험 및 자격증 연동 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">5</span>
                            자격시험 및 자격증 연동
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제11조 (응시 조건)</div>
                            <div className="privacy-section-text">
                                <p>
                                    응시회원은 본인확인을 완료해야 합니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제12조 (성적 및 자격증 연동)</div>
                            <div className="privacy-section-text">
                                <p>
                                    합격 여부는 자격관리규정 기준에 따라 결정되며, 회원 계정을 통해 확인할 수 있습니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제13조 (자격증 발급 및 수령)</div>
                            <div className="privacy-section-text">
                                <p>
                                    자격증 발급 기준을 충족한 회원은 실물 자격증 수령을 신청할 수 있습니다.
                                    실물 자격증 수령 신청 시 배송을 위한 주소 정보를 제출해야 하며,
                                    제출된 주소 정보는 자격증 배송 목적으로만 사용됩니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제14조 (자격증 재발급)</div>
                            <div className="privacy-section-text">
                                <p>
                                    분실 또는 훼손 시 재발급 신청이 가능하며, 수수료가 부과됩니다.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 제6장 개인정보 보호 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">6</span>
                            개인정보 보호
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제15조 (개인정보 수집 및 이용)</div>
                            <div className="privacy-section-text">
                                <p>
                                    개인정보는 회원 관리 및 서비스 제공 목적 범위에서만 수집 및 이용합니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제16조 (보관 및 파기)</div>
                            <div className="privacy-section-text">
                                <p>
                                    회원 탈퇴 시 정보를 즉시 파기하며, 법령에 따라 일부 정보는 보관할 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 제7장 회원 탈퇴 및 자격 정지 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">7</span>
                            회원 탈퇴 및 자격 정지
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제17조 (회원 탈퇴)</div>
                            <div className="privacy-section-text">
                                <p>
                                    회원은 언제든 탈퇴를 신청할 수 있습니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제18조 (회원 자격 정지)</div>
                            <div className="privacy-section-text">
                                <p>
                                    부정행위, 자격증 부정 사용 등 위반 시 자격이 정지될 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 제8장 부칙 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">8</span>
                            부칙
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제19조 (시행일)</div>
                            <div className="privacy-section-text">
                                <p>
                                    본 약관은 공지한 날로부터 시행합니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">제20조 (약관 변경)</div>
                            <div className="privacy-section-text">
                                <p>
                                    약관 변경 시 사이트를 통해 공지합니다.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="privacy-footer">
                        <div className="privacy-effective-date">
                            <strong>시행일자: 2025년 11월 30일</strong>
                            <br />
                            이 약관은 2025년 11월 30일부터 시행합니다.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsOfService;
